import {Breakpoints} from "@angular/cdk/layout";
export const BREAKPOINTS = {
  GreaterThanXSmall: [Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge],
  GreaterThanSmall: [Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge],
  Standard: Breakpoints
};
